<template lang="html">
  <div class="component-wrapper">
    <v-container>
      <div class="subtitle-1">Név:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="name_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="name_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Születési év:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="byear_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="byear_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Születési hónap:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="bmonth_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="bmonth_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Születési nap:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="bday_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="bday_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Kategória:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="categ_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="categ_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Tanuló azonosító:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="stud_id_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="stud_id_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">VIB iktató:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="vib_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="vib_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Telefonszám:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="phone_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="phone_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">E-mail:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="mail_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="mail_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Lakcím:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="address_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="address_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Iskola:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="school_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="school_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Oktató:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="teacher_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="teacher_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Kiadás dátuma:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="date_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="date_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Bélyegző:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="stamp_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="stamp_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">KRESZ év:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="kyear_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="kyear_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">KRESZ hónap:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="kmonth_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="kmonth_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">KRESZ nap:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="kday_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="kday_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="subtitle-1">Korlátozások:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="korl_x"
            label="Szélesség"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-text-field
            v-model="korl_y"
            label="Magasság"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
        <v-btn rounded color="primary" @click="saveCoordinates()">
          Mentés
          <v-icon right dark>save</v-icon>
        </v-btn>
        </v-col>
        <v-col>
        <v-btn rounded color="primary" @click="setDefault()">
          alapérték
          <v-icon right dark>autorenew</v-icon>
        </v-btn>
        </v-col>
      </v-row>

  </v-container>

  <v-snackbar v-model="save_coordinate_snackbar" bottom>
    {{save_coordinate_result}}
    <v-btn color="pink" text @click="save_coordinate_snackbar = false">
      Bezár
    </v-btn>
  </v-snackbar>

  </div>
</template>

<script>
import store from '../store'

import {
  mapFields
} from 'vuex-map-fields'

  export default {
    data () {
      return {
        save_coordinate_result: '',
        save_coordinate_snackbar: false,
        kday_x: '',
        kday_y: '',
        kmonth_x: '',
        kmonth_y: '',
        kyear_x: '',
        kyear_y: '',
        stamp_x: '',
        stamp_y: '',
        date_x: '',
        date_y: '',
        teacher_x: '',
        teacher_y: '',
        school_x: '',
        school_y: '',
        address_x: '',
        address_y: '',
        mail_x: '',
        mail_y: '',
        phone_x: '',
        phone_y: '',
        vib_x: '',
        vib_y: '',
        stud_id_x: '',
        stud_id_y: '',
        categ_x: '',
        categ_y: '',
        name_x: '',
        name_y: '',
        bday_x: '',
        bday_y: '',
        bmonth_x: '',
        bmonth_y: '',
        byear_x: '',
        byear_y: '',
        korl_x: '',
        korl_y: '',
      }
    },
    methods: {
      setDefault() {
        this.kday_x = 274
        this.kday_y = 67
        this.kmonth_x = 264
        this.kmonth_y = 67
        this.kyear_x = 251
        this.kyear_y = 67
        this.stamp_x = 232
        this.stamp_y = 160
        this.date_x = 205
        this.date_y = 168
        this.teacher_x = 210
        this.teacher_y = 157
        this.school_x = 202
        this.school_y = 147
        this.address_x = 210
        this.address_y = 130
        this.mail_x = 205
        this.mail_y = 121
        this.phone_x = 263
        this.phone_y = 121
        this.vib_x = 250
        this.vib_y = 53
        this.stud_id_x = 258
        this.stud_id_y = 111
        this.categ_x = 280
        this.categ_y = 38
        this.name_x = 200
        this.name_y = 111
        this.bday_x = 234
        this.bday_y = 115
        this.bmonth_x = 224
        this.bmonth_y = 115
        this.byear_x = 210
        this.byear_y = 115
      },
      getCoordinates: async function() {
        await this.gettoken()
        this.$http.post('/diakok/karton/get_coordinates', {
          token: this.token,
          loginuser: this.loginuser
        }).then((response) => {
          this.kday_x = response.data[0]['kday_x'];
          this.kday_y = response.data[0]['kday_y'];
          this.kmonth_x = response.data[0]['kmonth_x'];
          this.kmonth_y = response.data[0]['kmonth_y'];
          this.kyear_x = response.data[0]['kyear_x'];
          this.kyear_y = response.data[0]['kyear_y'];
          this.stamp_x = response.data[0]['stamp_x'];
          this.stamp_y = response.data[0]['stamp_y'];
          this.date_x = response.data[0]['date_x'];
          this.date_y = response.data[0]['date_y'];
          this.teacher_x = response.data[0]['teacher_x'];
          this.teacher_y = response.data[0]['teacher_y'];
          this.school_x = response.data[0]['school_x'];
          this.school_y = response.data[0]['school_y'];
          this.address_x = response.data[0]['address_x'];
          this.address_y = response.data[0]['address_y'];
          this.mail_x = response.data[0]['mail_x'];
          this.mail_y = response.data[0]['mail_y'];
          this.phone_x = response.data[0]['phone_x'];
          this.phone_y = response.data[0]['phone_y'];
          this.vib_x = response.data[0]['vib_x'];
          this.vib_y = response.data[0]['vib_y'];
          this.stud_id_x = response.data[0]['stud_id_x'];
          this.stud_id_y = response.data[0]['stud_id_y'];
          this.categ_x = response.data[0]['categ_x'];
          this.categ_y = response.data[0]['categ_y'];
          this.name_x = response.data[0]['name_x'];
          this.name_y = response.data[0]['name_y'];
          this.bday_x = response.data[0]['bday_x'];
          this.bday_y = response.data[0]['bday_y'];
          this.bmonth_x = response.data[0]['bmonth_x'];
          this.bmonth_y = response.data[0]['bmonth_y'];
          this.byear_x = response.data[0]['byear_x'];
          this.byear_y = response.data[0]['byear_y'];
          this.korl_x = response.data[0]['korl_x'];
          this.korl_y = response.data[0]['korl_y'];
        }, (error) => {
          this.error_text = error.data
        })
      },
      saveCoordinates: async function() {
        await this.gettoken()
        this.$http.post('/diakok/karton/save_coordinates', {
          token: this.token,
          loginuser: this.loginuser,
          kday_x: this.kday_x,
          kday_y: this.kday_y,
          kmonth_x: this.kmonth_x,
          kmonth_y: this.kmonth_y,
          kyear_x: this.kyear_x,
          kyear_y: this.kyear_y,
          stamp_x: this.stamp_x,
          stamp_y: this.stamp_y,
          date_x: this.date_x,
          date_y: this.date_y,
          teacher_x: this.teacher_x,
          teacher_y: this.teacher_y,
          school_x: this.school_x,
          school_y: this.school_y,
          address_x: this.address_x,
          address_y: this.address_y,
          mail_x: this.mail_x,
          mail_y: this.mail_y,
          phone_x: this.phone_x,
          phone_y: this.phone_y,
          vib_x: this.vib_x,
          vib_y: this.vib_y,
          stud_id_x: this.stud_id_x,
          stud_id_y: this.stud_id_y,
          categ_x: this.categ_x,
          categ_y: this.categ_y,
          name_x: this.name_x,
          name_y: this.name_y,
          bday_x: this.bday_x,
          bday_y: this.bday_y,
          bmonth_x: this.bmonth_x,
          bmonth_y: this.bmonth_y,
          byear_x: this.byear_x,
          byear_y: this.byear_y,
          korl_x: this.korl_x,
          korl_y: this.korl_y
        }).then((response) => {
          this.save_coordinate_snackbar = true
          this.save_coordinate_result = response.data
          this.getCoordinates()
        }, (error) => {
          this.error_text = error.data
        })
      },
    },
    mounted() {
      this.getCoordinates()
    },
    watch: {
      loginuser() {
        this.getCoordinates()
      }
    },
    computed: {
    ...mapFields([
      'auth.loginuser',
      'auth.placeid',
      'auth.phoneNumber',
      'auth.fbuser',
      'auth.admin',
  ]),
  }
  }
</script>

<style lang="css">
</style>
